import axios from 'axios';
import { API_ENDPOINTS } from '../constants';

// File type constants
export const ACCEPTED_FILE_TYPES = '.pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.txt';

export const handleViewFile = async (id: string) => {
  // Open tab first so iOS/Android browsers don't block the file open.
  const newTab = window.open('', '_blank');

  try {
    const response = await axios.get(`${API_ENDPOINTS.FILES}/download/${id}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    // Get the presigned URL from the response
    const { downloadUrl } = response.data;
    
    if (newTab) {
      newTab.location.href = downloadUrl;
    } else {
      // Fallback when popups are blocked.
      window.location.href = downloadUrl;
    }
  } catch (error) {
    if (newTab) {
      newTab.close();
    }
    console.error('Failed to open file:', error);
    throw new Error('Failed to open file');
  }
};

export const handleDeleteFile = async (id: string) => {
  try {
    await axios.delete(`${API_ENDPOINTS.FILES}/${id}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    return true;
  } catch (error) {
    console.error('Failed to delete file:', error);
    throw new Error('Failed to delete file');
  }
};
